export const SUPPLIER = {
  value: "SUPPLIER",
  key:
    "clients.client.categorisation.categoryForm.form.notorietyTypes.supplier",
};

export const PARTNER = {
  value: "PARTNER",
  key:
    "clients.client.categorisation.categoryForm.form.notorietyTypes.partner",
};

export const ACQUAINTANCE = {
  value: "ACQUAINTANCE",
  key:
    "clients.client.categorisation.categoryForm.form.notorietyTypes.acquaintance",
};

export const FOREIGN = {
  value: "FOREIGN",
  key:
    "clients.client.categorisation.categoryForm.form.notorietyTypes.foreign",
};

export default [SUPPLIER, PARTNER, ACQUAINTANCE, FOREIGN];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationNotorietyTypes.js